module.exports = __webpack_public_path__ + "static/media/olimar_0.8e5c8664.png";